<template>
  <div>
    <div>
      <h2>Import Investor</h2>
      <br />
      <p>
        Use this feature to import offline investment details for completed investments. New investors will be assigned a
        User ID and an Investment ID.
        For existing investors, please ensure you populate the User ID for accurate import. Click  <a :href="getImportTemplateLink()">here</a>  to download .csv
        template
      </p>
      <div v-if="!fileImported">
        <div class="row">
          <div class="form-group col-md-4 row pull-left">
            <label for="offering">Offering</label>
            <select v-model="selectedOfferingId" id="offering" class="form-control" name="offering">
              <option value="" disabled="disabled">--Select Offering--</option>
              <option v-for="offering in offerings" :value="offering.id">
                {{ offering.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-4 row pull-left">
            <label for="transactionStatus">Transaction Status</label>
            <select v-model="selectedTransactionStatus" id="transactionStatus" class="form-control"
              name="transactionStatus">
              <option value="" disabled="disabled">--Select Status--</option>
              <option value="doc_signed">Doc Signed</option>
              <option value="complete">Complete</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-4 row pull-left">
            <label for="csvFile">CSV File</label>
            <input type="file" id="csvFile" class="form-control" accept=".csv" @change="handleFileChange">
          </div>
        </div>
        <p v-if="message" class="text-danger">{{ message }}</p>
        <button type="button" class="btn btn-primary margin-top-10 margin-left-0 margin-bottom-20"
          @click="importData">Import</button>
      </div>
      <div v-else>
        <button type="button" class="btn btn-primary margin-top-10 margin-left-0 margin-bottom-20"
          @click="fileImported = false">Import Again</button>
        <table class="table">
          <thead>
            <tr>
              <th v-for="(column, label) in columns" @click="sort(label)">
                {{ column.label }}
              </th>
              <!-- <th>Actions</th> -->
              <th>Tax Forms</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="investor in investors" :key="investor.user.id">
              <td>{{ investor.user.id }}</td>
              <td>{{ investor.user.email }}</td>
              <td>{{ investor.user.full_name }}</td>
              <td>{{ dealingRepFormatter(investor.user.dealing_rep) }}</td>
              <td>
                <button type="button" class="btn btn-default btn-xs" @click="viewInvestments(investor)">View
                  Investments</button>
                <!-- <button type="button" class="btn btn-default btn-xs" @click.prevent="getInvestorInvite(investor)">Invite
                  Investor</button> -->
              </td>
              <td>
                <label class="checkbox-inline">
                  <input type="checkbox" :name="`tax-form-individual${investor.user.id}`" :value="investor.user.id"
                    v-model="investor.investment_types.individual" disabled />
                  Individual</label>
                <label class="checkbox-inline">
                  <input type="checkbox" :name="`tax-form-entity${investor.user.id}`" :value="investor.user.id"
                    v-model="investor.investment_types.entity" disabled />
                  Entity</label>
                <label class="checkbox-inline">
                  <input type="checkbox" :name="`tax-form-entity${investor.user.id}`" :value="investor.user.id"
                    v-model="investor.investment_types.joint" disabled />
                  Joint</label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
  
<script>
import axios from "axios";
export default {
  name: "InvestorImport",
  components: {
  },
  props: {
    'activeEmd': Object,
  },
  computed: {
  },
  methods: {
    getOfferings() {
      axios.get('get_all_offerings')
        .then((res) => {
          const offerings = res.data && res.data.offerings ? res.data && res.data.offerings : {};
          this.offerings = Object.values(offerings);
        })
        .catch((error) => {
          console.error('Error fetching offerings:', error);
        });
    },
    handleFileChange(event) {
      this.selectedFile = event.target.files[0];
    },
    importData() {
      if (!this.selectedOfferingId) {
        this.message = "Please select an offering.";
        return;
      }

      if (!this.selectedTransactionStatus) {
        this.message = "Please select a transaction status.";
        return;
      }

      if (!this.selectedFile) {
        this.message = "Please select a CSV file.";
        return;
      }
      this.message = "";
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      formData.append('offeringId', this.selectedOfferingId);
      formData.append('transactionStatus', this.selectedTransactionStatus);

      axios.post('import_investments', formData)
        .then((response) => {
          const uniqueUserInvestmentsArray = Object.keys(response.data.uniqueUserInvestments)
            .map(userId => ({ userId, ...response.data.uniqueUserInvestments[userId] }));
          this.investors = uniqueUserInvestmentsArray;
          this.fileImported = true;
        })
        .catch((error) => {
          if (error.response &&  error.response.data && error.response.data.error) {
            this.message = error.response.data.error;
          } else {
            this.message = "Error importing data. Please try again.";
          }
        });
    },
    sort(column) {
      if (this.sortBy === column) {
        this.sortDir *= -1;
      }

      this.sortBy = column;
    },
    dealingRepFormatter(dealingRep) {
      if (!dealingRep) {
        return ""
      } else {
        return dealingRep.full_name
      }
    },
    reset() {
      this.investors = [];
      this.fileImported = false;
    },
    viewInvestments(investor) {
      this.saveFilter(this.statusFilter)
      window.location.href = 'console?filterByName=' + investor.investor.full_name
    },
    getImportTemplateLink() {
      const currentLocation = window.location;
      const baseUrl = `${currentLocation.protocol}//${currentLocation.host}`;
      
      return `${baseUrl}/admin/get_import_template`;
    },
  },
  data() {
    return {
      offerings: [],
      investors: [],
      selectedFile: null,
      selectedOfferingId: null,
      selectedTransactionStatus: null,
      message: "",
      fileImported: false,
      columns: {
        userId: {
          label: 'User ID',
          sort: i => i.user.id
        },
        email: {
          label: 'User Email',
          sort: i => i.user.email
        },
        user_name: {
          label: 'User Name',
          sort: i => i.user.full_name
        },
        dealing_rep: {
          label: 'Dealing Rep',
          sort: i => i.user.full_name
        },
      }
    }
  },
  mounted() {
    this.getOfferings()
  }
}
</script>